import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { DashboardStorageMovementsComponent } from './storage-movements.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.STORAGE_MOVEMENTS' };
var routes = [
    {
        path: 'relatorios/movimentacoes',
        component: DashboardStorageMovementsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var DashboardStorageMovementsModule = /** @class */ (function () {
    function DashboardStorageMovementsModule() {
    }
    return DashboardStorageMovementsModule;
}());
export { DashboardStorageMovementsModule };
export { ɵ0 };
